// src/components/DateInput.js
import React, { useState } from 'react';

export default function DateInput({ onSubmit }) {
    const [date, setDate] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!date) {
            alert('Please select a date in the YYYY-MM-DD format.');
            return;
        }
        onSubmit(date);
    };

    // Limit to today or earlier
    // const maxDate = new Date().toISOString().split('T')[0];

    return (
        <form onSubmit={handleSubmit} style={{ marginBottom: '1rem' }}>
            <input
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
                required
            />
            <button type="submit">Submit</button>
        </form>
    );
}
